import script from "./SALGraficaPareto.vue?vue&type=script&setup=true&lang=js"
export * from "./SALGraficaPareto.vue?vue&type=script&setup=true&lang=js"

import "./SALGraficaPareto.vue?vue&type=style&index=0&id=3bd07efa&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd07efa"]])

export default __exports__